import { UserTicketsModel } from '../../types/loginTypes';
import { UserVirtualOfficeLicence } from '../Settings/settings.types';

export interface Payment {
  amount: string;
  currencyType: number;
  dateCreated: string; // ISO date string
}

export interface MyOrderListModel {
  price: number;
  payments: Payment[];
  amountToPay: number;
  name: string;
  type: number;
  orderId: number;
  status: number;
  dateCreated: string; // ISO date string
  datePaid: string | null; // Nullable ISO date string
  currencyType: number;
  networkType: number;
  paymentAddress: string;
  currencyAmountToPay: string;
  paymentUrl: string;
  totalPrice?: number;
  vatPrice?: number;
  feePrice?: number;
  vatPercentage?: number;
}

export interface GetMyPackageInfoResponse {
  orders: MyOrderListModel[];
}

export interface PackageModel {
  benefits: any;
  id: number;
  name: string;
  price: number;
  teamBonusPercent: number;
  order: number;
  stakeRatio: number;
  weekCapRuleLimit: number;
  volumePoints: number;
  type: number;
  tickets: string | number;
  subtitle2: string;
}

export interface GetPackagesResponse {
  products: PackageModel[];
}

export interface UserPackageModel {
  id: number;
  price: number;
  shoppingPoints: number;
  donationPoints: number;
  teamBonusPercent: number;
  status: number;
  dateCreated: string;
  datePaid: string;
  networkType: number;
  paymentAddress: string;
  currencyType: number;
  networkCurrencyType: string;
  package: {
    packageId: number;
    name: string;
    price: number;
    teamBonusPercent: number;
    order: number;
    stakeRatio: number;
    weekCapRuleLimit: number;
    volumePoints: number;
    type: number;
  };
  packageRank: {
    packageRankId: number;
    name: string;
  };
  nextPackageRank: {
    packageRankId: number;
    name: string;
  };
}

export interface Subscription {
  id: number;
  price: number;
  status: number;
  dateCreated: string; // ISO string format for dates
  dateEnd: string | null;
  datePaid: string | null;
  networkType: number;
  paymentAddress: string;
  currencyType: number;
  networkCurrencyType: number;
}

export interface AddPackageForUserResponse {
  userPackage: UserPackageModel;
  userTickets: UserTicketsModel;
  userVirtualOfficeLicence: UserVirtualOfficeLicence | null;
  subscription?: Subscription | null;
}

export interface MergedPackageModel extends PackageModel {
  id: number;
  image: string;
  title: string;
  price: number;
  weeklyCap: string;
  orderPlan: string;
  ranking: string;
  benefits: Benefit[];
  bonuses: Bonus[];
  firstGift: string;
  proRankBoost: number;
  calculator: string;
  limitedQuantity: boolean;

  dobuleTradingBinaries: number;
  membershipBenefits: string[];
  extraTools: string[];
}

export interface GoldenCard {
  id: number;
  price: number;
  name: string;
  totalPrice: number;
  vatPercentage: number;
  vatPrice: number;
}

export interface UserAddress {
  address: string;
  city: string;
  country: string;
  countryCode: string;
  zipCode: string;
}

interface Benefit {
  icon: number;
  text: string;
}

interface Bonus {
  icon: number;
  text: string;
}

export enum PurchaseSteps {
  PAYMENT_METHOD,
  PAYMENT_PAGE,
  SUCCESS,
  FAILED
}

export enum Tokens {
  TETHER,
  USDC
}

export enum TokenCurrencyType {
  TETHER = 1,
  USDC = 7
}

export enum SubsctriptionTypes {
  TRAVEL_PACKAGES = 2,
  SUBSCRIPTION = 7,
  GOLDEN_CARD = 9,
  SUBCRIPTION_BUNDLE = 8,
  SUPER_SALES = 10
}
